var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinned = function SvgPinned(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.218,349.732a2.5,2.5,0,0,0-3.536,0l-.354.354-3.207-3.207a2.5,2.5,0,0,0-.318-3.147,2.56,2.56,0,0,0-3.535,0l-3.536,3.536a2.5,2.5,0,0,0,3.146,3.853l3.208,3.207-.354.354a2.5,2.5,0,0,0,0,3.535h0a2.5,2.5,0,0,0,3.536,0l1.768-1.768,1.414,1.414a1,1,0,1,0,1.414-1.414l-1.414-1.414,1.768-1.768A2.5,2.5,0,0,0,67.218,349.732Zm-9.89.011a1,1,0,1,0-1.414-1.414l-1.061,1.06a.5.5,0,0,1-.707-.707l3.537-3.536a.5.5,0,1,1,.706.707.988.988,0,0,0-.142.213.972.972,0,0,0-.211.141,1,1,0,0,0,0,1.414l3.878,3.879L60.5,352.914Zm8.475,2.111L60.854,356.8a.5.5,0,0,1-.708,0,.5.5,0,0,1,0-.707l4.95-4.95a.5.5,0,0,1,.707,0A.5.5,0,0,1,65.8,351.854Z",
    transform: "translate(-48 -339)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinned.3fdb4a5f.svg";
export { ForwardRef as ReactComponent };